/**** Open Strees Maps reverse Geocoding */
import axios from "axios";

export const FuelPrice = async () => {
	const link = `https://api.data.gov.my/data-catalogue/?id=fuelprice&limit=5&sort=-date&range=diesel[0:999]`;
	var result = [];

	try {
		const response = await axios.get(link);
		const json = response.data;

		if (json && json.length > 0) {
			// Find the record with series_type === 'level'
			// This avoids picking up the 'change_weekly' value (e.g., 0.5)
			const levelData = json.find((item) => item.series_type === "level");
			const result = levelData ? levelData.diesel : json[0].diesel;
			return result;
		} else {
			return 0;
		}
	} catch (err) {
		// console.log(err);
		return 0;
	}
};
